import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import TasksModule from '@modules/TasksModule';
import CustomTaskRow from './components/CustomTaskRow/CustomTaskRow';
import CustomTaskView from './components/CustomTaskView/CustomTaskView';
import { v4 as uuidv4 } from 'uuid';
import { TaskState } from '@modules/TasksModule/types';

// This function is exposed globally for testing purposes.
(window as any).addCustomTask = function (displayName = 'Custom Task') {
  const id = uuidv4();
  TasksModule.createTask({
    id,
    from: 'from-field',
    to: 'to-field',
    displayName,
    type: 'custom-task',
    state: TaskState.Offered,
    isStateActive: true,
    attributes: {
      foo: 'bar',
    },
  });
};

class CustomTasksModule extends AppModule {
  override events = [];

  override preload(): void {
    TasksModule.registerTaskDefinition({
      key: 'custom-task',
      category: 'Custom',
      types: ['custom-task'],
      taskRowComponent: CustomTaskRow,
      taskViewComponent: CustomTaskView,
    });
  }
}

export default new CustomTasksModule(
  appManager.events,
  appManager.logger('Custom'),
);
